<template>
  <div id="app">
    <!--Header Starts Here-->
    <nav class="navbar navbar-expand-lg navbar-default navbar-dark navbar-custom navbar-custom-dark bg-dark">
        <div class="container">
            <!-- LOGO -->
            <a class="navbar-brand logo" href="index.html">
                <img src="static/images/logo_white.png" class="logo" alt="logo">
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <ul class="nav navbar-nav ml-auto navbar-center" id="mySidenav">
                    <li class="nav-item">
                        <a href="#home" class="nav-link scroll">{{$t('Header.home')}}</a>
                    </li>
                    <li class="nav-item">
                        <a href="#features" class="nav-link scroll">{{$t('Header.keyFacts')}}</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{{$t('lang')}}</a>
                        <div class="dropdown-menu">
                          <a class="dropdown-item" href="#" @click.prevent="$locale.change('fr')">FR</a>
                          <a class="dropdown-item" href="#" @click.prevent="$locale.change('en')">EN</a>
                      </div>
                  </li>
                        <!--
                        <li class="nav-item">
                            <a href="#pricing" class="nav-link scroll">Pricing</a>
                        </li>
                        <li class="nav-item">
                            <a href="#clients" class="nav-link scroll">Clients</a>
                        </li>
                        <li class="nav-item">
                            <a href="#faqs" class="nav-link scroll">Faq</a>
                        </li>
                    -->
                </ul>
            </div>
        </div>
    </nav>
    <!--Header End Here-->
    <router-view></router-view>
    <!--Footer Start -->
        <footer class="bg-dark footer-one"><!--
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 p-b-40">
                        <img src="static/images/logo_white.png" alt="logo" class="footer-logo" height="40">
                        <p class="about-text">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC,making it over 2000 years old.</p>
                        <p class="about-text">Nunc nec dui vitae urna cursus lacinia. In venenatis egetjusto in dictum.</p>
                    </div>
                    <div class="col-lg-2">
                        <h5>Company</h5>
                        <ul class="list-unstyled">
                            <li><a href="">About Us</a></li>
                            <li><a href="">Features</a></li>
                            <li><a href="">FAQ</a></li>
                            <li><a href="">Services</a></li>
                        </ul>
                    </div>
                    <div class="col-lg-2 p-b-40">
                        <h5>Support</h5>
                        <ul class="list-unstyled">
                            <li><a href="">Help & Support</a></li>
                            <li><a href="">Privacy Policy</a></li>
                            <li><a href="">Terms & Conditions</a></li>
                        </ul>
                    </div>
                    <div class="col-lg-4">
                        <div>
                            <h5>Contact us</h5>
                            <ul class="list-unstyled">
                                <li><strong class="font-secondary font-14">Address:</strong> 795 Folsom Ave, Suite 600 CA 94107</li>
                                <li><strong class="font-secondary font-14">Phone:</strong> (123) 456-7890, 123-4567 89 </li>
                                <li><strong class="font-secondary font-14">Email:</strong> <a href="mailto:first.last@example.com">first.last@example.com</a></li>
                            </ul>
                        </div>
                    </div>
                </div> --><!-- end row --><!--
            </div>-->
            <!-- end container -->
            <div class="footer-one-alt">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-4">
                            <p class="m-b-0 font-13 copyright">© 2019 Foxypark</p>
                        </div>
                        <div class="col-sm-4">
                            <p class="m-b-0 font-13 copyright"><a href="#">{{$t('Home.footer.terms')}}</a></p>
                        </div>
                        <div class="col-sm-4">
                            <ul class="list-inline footer-social-one m-b-0 float-right">
                                <li class="list-inline-item"><a href="https://www.facebook.com/Foxypark" target="_blank"><i class="pe-so-facebook"></i></a></li>
                                <li class="list-inline-item"><a href="http://www.instagram.com/foxypark_app" target="_blank"><i class="pe-so-instagram"></i></a></li>
                                <!--
                                <li class="list-inline-item"><a href="#"><i class="pe-so-twitter"></i></a></li>
                                <li class="list-inline-item"><a href="#"><i class="pe-so-linkedin"></i></a></li>
                                <li class="list-inline-item"><a href="#"><i class="pe-so-google-plus"></i></a></li>
                                <li class="list-inline-item"><a href="#"><i class="pe-so-skype"></i></a></li>-->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <cookie-law theme="dark-lime">
                <div slot-scope="props" class="cookie-law__container">
                    <p class="cookie-law__details">{{$t('cookie_law.message')}}</p>
                    <div class="cookie-law__actions">
                        <button class="cookie-law__action cookie-law__accept-btn" @click="props.accept"><span>{{$t('cookie_law.accept')}}</span></button>
                        <button class="cookie-law__action cookie-law__refuse-btn" @click="props.close"><span>{{$t('cookie_law.refuse')}}</span></button>
                    </div>
                </div>
            </cookie-law>
        </footer>
    </div>
</template>

<script>
    import CookieLaw from 'vue-cookie-law'
    export default {
      name: 'App',
      components: {
        CookieLaw
    },
    methods: {
        changeLang: function (newLang) {
          if (this.$cookies.get('lang_chap') !== newLang) {
            this.$cookies.set('lang_chap', newLang, 'Infinity')
            this.$locale.change(newLang)
            location.reload()
        }
    }
},
mounted: function () {
    if (this.$cookies.get('lang_chap') === '') {
      this.$cookies.set('lang_chap', 'fr', 'Infinity')
  }
  this.$locale.change(this.$cookies.get('lang_chap'))
}
}
</script>

<style scoped>
.cookie-law__container {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    align-items: center;
    flex-wrap: wrap;
}
.cookie-law__details {
    margin-bottom: unset;
    margin-right: 18px;
    margin-bottom: 10px;
}
.cookie-law__actions {

}
.cookie-law__action {
    padding: 6px 12px;
    border: 1px solid;
    border-radius: 3px;
    color: white;
    transition: 0.2s;
    cursor: pointer;
    outline: none;
}
.cookie-law__action:hover {
    filter: brightness(95%);
}
.cookie-law__accept-btn {
    margin-right: 8px;
    background-color: #28a745;
    border-color: #28a745;
}
.cookie-law__refuse-btn {
    background-color: #bd2130;
    border-color: #b21f2d;
}
</style>



// WEBPACK FOOTER //
// App.vue?6d253fa3